<div class="st-error-header">
    <mat-icon class="material-icons-outlined">error_outline</mat-icon>
    <div class="st-error-header-title">{{ title }}</div>
</div>
<div class="st-error-body">
    {{message}}
</div>
<div class="st-error-footer">
    <button mat-button
            class="st-error-button-continue"
            (click)="onContinueClick()"
            cdkInitialFocus>
        {{continue}}
    </button>
</div>